jQuery.fn.pagezoom = function (fn) {
  jQuery(document).keydown(function (e) {
    var browser = WA.ENV.browser.name.toLowerCase();
    switch (true) {
      case browser === 'firefox' || browser === 'ie':        
        if (e.ctrlKey && (
              e.which == 187 ||
              e.which == 189 ||
              e.which == 107 ||
              e.which == 109 ||
              e.which == 96 ||
              e.which == 48
            )) fn();
        break;
      case browser === 'opera':
        if (
              e.which == 43 ||
              e.which == 45 ||
              e.which == 42 ||
              (e.ctrlKey && e.which == 48)
            ) fn();
        break;
      case browser === 'safari':
        if (e.metaKey && (
              e.charCode == 43 ||
              e.charCode == 45
            )) fn();
        break;
    }
    return;
  });

  jQuery(document).bind('mousewheel', function (e) {
    if (e.ctrlKey) fn();
  });

  jQuery(document).bind('DOMMouseScroll', function (e) {
    if (e.ctrlKey) fn();
  });
};